module.exports = __webpack_public_path__ + "static/bottom-61ac3f2ad1028f948d93e2c83fec0d18.png";